import { createAction } from '@reduxjs/toolkit';

import { CREATE_ELEMENT, ELEMENT_ACTION, ERROR, MNS_CONNECTION_STATE_CHANGE, OVERRIDE, VIDEO_ID } from './actionTypes';

/**
 * @typedef {Object} CreateElementInfo
 * @property {string} element_id
 * @property {button|fullscreen|display} element_type
 * @property {boolean} clickable
 * @property {Object} content -  in case display_emoji {name: string, count: number}
 */

// Application actions
export const updateTimer = createAction('APP/SET TIME');

// Manage application states
/**
 * @function
 * @param {boolean} isLoaded
 */
export const appLoaded = createAction('APP/LOADED');
/**
 *
 * @param {string} sessionId
 * @deprecated Due to does not have own sense
 */
export const appReady = createAction('APP/READY');

/**
 * Complementary to interactiveStart,
 * @todo consistent naming
 * @param {void}
 */
export const appStarted = createAction('APP/STARTED');

// External command to INTERACTIVE, usually from host application
export const interactivePause = createAction('INTERACTIVE/PAUSE');
export const interactiveResume = createAction('INTERACTIVE/RESUME');
export const interactiveStop = createAction('INTERACTIVE/STOP');
export const interactiveStart = createAction('INTERACTIVE/START');

export const interactiveCreate = createAction('INTERACTIVE/CREATE');
export const interactiveResize = createAction('INTERACTIVE/RESIZE');

// MNS related actions
export const mnsConnectionStateChange = createAction(
  MNS_CONNECTION_STATE_CHANGE,
);
export const setDebug = createAction('APP/SET DEBUG');
export const appActions = {
  appError: (fatal, message, meta = {}) => ({
    type: ERROR,
    payload: {
      fatal,
      message,
    },
    meta,
  }),
  //DATA
  override: (elements) => ({
    type: OVERRIDE,
    payload: elements,
  }),
  videoId: (id) => ({
    type: VIDEO_ID,
    payload: id,
  }),
  //UI
  /**
   *
   * @param {CreateElementInfo} info
   * @param {Object} meta
   * @return {{payload: *, type: string}}
   */
  createElement: (info, meta) => ({
    type: CREATE_ELEMENT,
    payload: info,
    meta,
  }),

  /**
   * Очень странный и стрёмный action,
   * изначально он задумывался как способ передачи в интерактив юзерских действий на стороне клиента.
   * В частности: взаимодействие с прокси контролами.
   * В настоящий момент обработчики этих действия назначаются в момент «создания» прокси контрола,
   * и запускаются, если доступны из обработчика onMessage.
   * В то же время он используеться для обновления вкл./выкл. расширений в рантайме.
   * @param info
   * @return {{payload, type: string}}
   */
  elementAction: (info) => ({
    type: ELEMENT_ACTION,
    payload: info,
  }),
};
